import {gql} from "@irati/utils/gql"

export const PointsRequestFragment = gql`
  fragment PointsRequestFragment on PointsRequest {
    uuid
    approver {
      uuid
      firstName
      lastName
    }
    requester {
      uuid
      firstName
      lastName
    }
    reason
    amount
    utcDateSubmitted
    utcDateUpdated
    status
    responseMessage
    budget {
      uuid
      name
      walletId
    }
  }
`
